import { fundChannel } from '@/utils/dictionary'
export const getChannel = (value: string | number) => {
  if (!value) return '--'
  const valueType = value.toString()
  return fundChannel.find(item => item.label === valueType)?.value || '--'
}
